import Link from "@mui/material/Link";
import { ArrowBackOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router";

export default function BackLink() {
  const navigate = useNavigate();

  // Show the Link only when the Navigation API confirms a same-origin history entry.
  if (!window.navigation?.canGoBack) {
    return null;
  }

  return (
    <Link
      component={"button"}
      type={"button"}
      onClick={() => navigate(-1)}
      underline={"always"}
      sx={{ display: "inline-flex", alignItems: "center", marginBottom: "0.5rem" }}
    >
      <ArrowBackOutlined fontSize={"small"} />
      Zurück
    </Link>
  );
}
